import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  Grid,
  Paper,
  Dialog,
  Snackbar,
  Alert,
  CircularProgress,
  Backdrop,
  DialogTitle,
  DialogContent
} from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ImageIcon from '@mui/icons-material/Image';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { IconFileSpreadsheet } from '@tabler/icons';
// import { FiBankList } from 'API/Reports';
import { IoMdClose } from 'react-icons/io';
import { FiBankListM, MandateFileUpLoad } from 'API/Mandate_Surrender';

const FileUpload = (props) => {
  const [bank, setBank] = useState('');
  // const [bankError, setBankError] = useState(false);
  const [excelFile, setExcelFile] = useState(null);
  const [mandateFile, setMandateFile] = useState(null);
  const [BankList, setBankList] = useState([]);
  const [previewFile, setPreviewFile] = useState(null);
  const [Error, setError] = useState(false);
  const [SuccessMsg, setSuccessMsg] = useState(false);
  const [Isloading, setIsloading] = useState(false);
  const [IsloadingBank, setIsloadingBank] = useState(false);

  useEffect(() => {
    FiBankListM(setIsloadingBank, setBankList);
  }, []);

  const handleFileUpload = (event, type) => {
    if (!bank) {
      setError('Please select a bank before uploading a file.');
      return;
    }

    const file = event.target.files[0];
    if (!file) return;

    const allowedExcel = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
    const allowedMandate = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];

    if (type === 'excel' && allowedExcel.includes(file.type)) {
      setExcelFile(file);
    } else if (type === 'mandate' && allowedMandate.includes(file.type)) {
      setMandateFile(file);
    } else {
      setError('Invalid file type. Please upload the correct format.');
    }
  };

  const handleDeleteFile = (type) => {
    if (type === 'excel') {
      setExcelFile(null);
    } else {
      setMandateFile(null);
    }
  };

  // const [previewFile, setPreviewFile] = useState(null);
  const [previewURL, setPreviewURL] = useState('');

  const handlePreview = (file) => {
    if (file instanceof File) {
      const fileURL = URL.createObjectURL(file);
      setPreviewFile(file);
      setPreviewURL(fileURL);
    } else {
      console.error('Invalid file object for preview.');
    }
  };

  const handleClosePreview = () => {
    setPreviewFile(null);
    setPreviewURL(''); // Clear URL
  };

  // Cleanup: Revoke the object URL when preview is closed
  useEffect(() => {
    return () => {
      if (previewURL) {
        URL.revokeObjectURL(previewURL);
      }
    };
  }, [previewURL]);

  const handleSubmit = () => {
    // if (files.length !== 0) {
    MandateFileUpLoad(mandateFile, excelFile, bank, setIsloading, setSuccessMsg, setError, props.setOpen, props.refuntion);
    // } else {
    //   setError('Please upload a files before submit.');
    // }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', p: 1 }}>
      <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={Isloading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={SuccessMsg}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setSuccessMsg(false)}
      >
        <Alert onClose={() => setSuccessMsg(false)} severity="success" variant="filled" sx={{ width: '100%' }}>
          {SuccessMsg}
        </Alert>
      </Snackbar>
      <Snackbar
        open={Error}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setError(false)}
      >
        <Alert onClose={() => setError(false)} severity="error" variant="filled" sx={{ width: '100%' }}>
          {Error}
        </Alert>
      </Snackbar>
      {/* Bank Selection */}
      <FormControl fullWidth variant="outlined" sx={{ mb: 2, mt: 1 }}>
        <InputLabel>Select Bank</InputLabel>
        <Select value={bank} onChange={(e) => setBank(e.target.value)} label="Select Bank">
          <MenuItem value="" disabled>
            Select
          </MenuItem>
          {IsloadingBank && (
            <MenuItem value={'select'} disabled>
              <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={IsloadingBank}>
                <CircularProgress color="inherit" />
              </Backdrop>
            </MenuItem>
          )}
          {BankList&&BankList.length>0?BankList.map((bank, index) => (
            <MenuItem value={bank.Bankname} key={index}>
              {bank.Full_Bank_Name.toUpperCase()}
            </MenuItem>
          )):
          <MenuItem sx={{pointerEvents:'none',display: 'flex', justifyContent: 'center'}}>No bank data found</MenuItem>
          }
        </Select>
      </FormControl>
      {/* File Upload Sections */}
      <Paper sx={{ p: 2, mb: 2, border: '1px solid #ccc', borderRadius: 2 }}>
        <Typography sx={{ fontWeight: 'bold', mb: 1 }}>Excel File</Typography>
        {excelFile ? (
          <Paper sx={{ display: 'flex', alignItems: 'center', p: 1, mb: 1, border: '1px solid #ccc', borderRadius: 1 }}>
            <IconFileSpreadsheet style={{ color: '#2ecc71' }} />
            <Typography variant="body2" sx={{ ml: 1, flex: 1 }}>
              {excelFile.name}
            </Typography>
            <IconButton onClick={() => handleDeleteFile('excel')}>
              <DeleteIcon color="error" />
            </IconButton>
          </Paper>
        ) : (
          <Button variant="outlined" color="secondary" component="label" fullWidth>
            Click to Upload Document
            <input type="file" hidden onChange={(e) => handleFileUpload(e, 'excel')} accept=".xlsx,.xls" />
          </Button>
        )}
      </Paper>
      <Paper sx={{ p: 2, mb: 2, border: '1px solid #ccc', borderRadius: 2 }}>
        <Typography sx={{ fontWeight: 'bold', mb: 1 }}>Bank Mandate File</Typography>
        {mandateFile ? (
          <Paper sx={{ display: 'flex', alignItems: 'center', p: 1, mb: 1, border: '1px solid #ccc', borderRadius: 1 }}>
            {mandateFile.type.includes('pdf') ? <PictureAsPdfIcon color="error" /> : <ImageIcon color="primary" />}
            <Typography variant="body2" sx={{ ml: 1, flex: 1 }}>
              {mandateFile.name}
            </Typography>
            <IconButton color="secondary" onClick={() => handlePreview(mandateFile)}>
              <VisibilityIcon />
            </IconButton>
            <IconButton onClick={() => handleDeleteFile('mandate')}>
              <DeleteIcon color="error" />
            </IconButton>
          </Paper>
        ) : (
          <Button variant="outlined" color="secondary" component="label" fullWidth>
            Click to Upload Document
            <input type="file" hidden onChange={(e) => handleFileUpload(e, 'mandate')} accept=".pdf,.jpg,.jpeg,.png" />
          </Button>
        )}
      </Paper>
      {/* Buttons */}
      <Grid container spacing={2} sx={{ mt: 1, mb: 1 }} justifyContent="center">
        <Grid item xs={6}>
          <Button
            fullWidth
            variant="contained"
            color="secondary"
            sx={{
              backgroundColor: '#688B2A',
              color: '#FFFFFF',
              borderRadius: '6px',
              '&:hover': {
                backgroundColor: '#688B2A'
              }
            }}
            disabled={!bank || !excelFile || !mandateFile}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </Grid>
      </Grid>
      {/* Preview Dialog */}
      <Dialog open={!!previewFile} onClose={handleClosePreview} maxWidth="md" fullWidth>
        <DialogTitle>
          File Preview
          <IconButton onClick={handleClosePreview} sx={{ position: 'absolute', right: 10, top: 10 }}>
            <IoMdClose />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {previewFile?.type.includes('pdf') ? (
            <iframe src={previewURL} width="100%" height="500px" title="PDF Preview" />
          ) : (
            <img src={previewURL} alt="Preview" style={{ width: '100%', maxHeight: '500px', objectFit: 'contain' }} />
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default FileUpload;
